import React from 'react';
import { Chip, Grid, Paper, Stack, Typography } from '@mui/material';
import { AutoOutgoingInvoiceCandidateDto } from '../Types/ksefOutgoing.types';

interface KsefOutgoingDetailsSnapshot {
  state?: string;
  ksefStatusCode?: number;
  ksefStatusDescription?: string;
  hasUpoFile?: boolean;
  correlationId?: string;
  errorCode?: string;
  lastPolledAtUtc?: string;
}

interface KsefOutgoingDetailsPanelProps {
  selectedInvoiceId: string;
  selectedInvoiceNumber?: string;
  selectedCandidate?: AutoOutgoingInvoiceCandidateDto;
  snapshot?: KsefOutgoingDetailsSnapshot;
  stateLabelResolver?: (state?: string | null) => string | null | undefined;
  decisionLabelResolver?: (decision?: string | null) => string | null | undefined;
}

const renderValue = (value: string | number | boolean | null | undefined): string => {
  if (value === null || value === undefined || value === '') {
    return '-';
  }

  if (typeof value === 'boolean') {
    return value ? 'true' : 'false';
  }

  return String(value);
};

const KsefOutgoingDetailsPanel = ({
  selectedInvoiceId,
  selectedInvoiceNumber,
  selectedCandidate,
  snapshot,
  stateLabelResolver,
  decisionLabelResolver,
}: KsefOutgoingDetailsPanelProps) => {
  return (
    <Paper sx={{ p: 3 }}>
      <Stack spacing={2}>
        <Typography variant="h6">Szczegóły wysyłki</Typography>

        <Stack direction="row" spacing={1}>
          <Chip label={`InvoiceId: ${renderValue(selectedInvoiceId)}`} />
          <Chip label={`InvoiceNumber: ${renderValue(selectedInvoiceNumber)}`} />
        </Stack>

        <Grid container spacing={2}>
          <Grid size={{ xs: 12, md: 4 }}>
            <Typography variant="body2" color="text.secondary">
              Status
            </Typography>
            <Typography variant="body1">
              {renderValue(stateLabelResolver?.(snapshot?.state) ?? snapshot?.state)}
            </Typography>
          </Grid>
          <Grid size={{ xs: 12, md: 4 }}>
            <Typography variant="body2" color="text.secondary">
              Kod statusu KSeF
            </Typography>
            <Typography variant="body1">{renderValue(snapshot?.ksefStatusCode)}</Typography>
          </Grid>
          <Grid size={{ xs: 12, md: 4 }}>
            <Typography variant="body2" color="text.secondary">
              Opis statusu KSeF
            </Typography>
            <Typography variant="body1">{renderValue(snapshot?.ksefStatusDescription)}</Typography>
          </Grid>

          <Grid size={{ xs: 12, md: 4 }}>
            <Typography variant="body2" color="text.secondary">
              Czy ma plik UPO
            </Typography>
            <Typography variant="body1">{renderValue(snapshot?.hasUpoFile)}</Typography>
          </Grid>
          <Grid size={{ xs: 12, md: 4 }}>
            <Typography variant="body2" color="text.secondary">
              Ostatnie odpytywanie
            </Typography>
            <Typography variant="body1">{renderValue(snapshot?.lastPolledAtUtc)}</Typography>
          </Grid>
          <Grid size={{ xs: 12, md: 4 }}>
            <Typography variant="body2" color="text.secondary">
              ID korelacji
            </Typography>
            <Typography variant="body1">{renderValue(snapshot?.correlationId)}</Typography>
          </Grid>

          <Grid size={{ xs: 12, md: 6 }}>
            <Typography variant="body2" color="text.secondary">
              Kod błędu
            </Typography>
            <Typography variant="body1">{renderValue(snapshot?.errorCode)}</Typography>
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <Typography variant="body2" color="text.secondary">
              Decyzja kwalifikacji
            </Typography>
            <Typography variant="body1">
              {renderValue(
                decisionLabelResolver?.(selectedCandidate?.eligibilityDecision?.decision) ??
                  selectedCandidate?.eligibilityDecision?.decision
              )}
            </Typography>
          </Grid>
        </Grid>
      </Stack>
    </Paper>
  );
};

export default KsefOutgoingDetailsPanel;
